/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
})
export class NavigationMenuComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() menuDataUrl: string;
  @Input() postFavouritesUrl: string;
  @Input() userName: string;
  @Input() pictureUrl: string;
  @Input() myProfileUrl: string;
  @Input() contactUrl: string;
  @Input() activeMenuItem: string;
  @Input() logoutUrl: string;
  @Input() defaultService = 'Data Collection Service';

  public menuDataUrlSafe: string;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.menuDataUrl &&
      changes.menuDataUrl.currentValue &&
      changes.menuDataUrl.currentValue.length > 0
    ) {
      this.menuDataUrlSafe = changes.menuDataUrl.currentValue;
    }

    if (changes.activeMenuItem && changes.activeMenuItem.currentValue) {
      this.activeMenuItem = changes.activeMenuItem.currentValue;
    }
  }
}
